export default "__VITE_ASSET__DlonV36l__"